'use client';
import { useUser } from '@/app_lib/providers/UserProvider';
import { AmplitudeScript } from '@/app_lib/scripts/Amplitude';
import { MixpanelScript } from '@/app_lib/scripts/MixPanelScript';
import { OptimizelyScript } from '@/app_lib/scripts/OptimizelyScript';
import { PushlyScript } from '@/app_lib/scripts/Pushly';

export const EssentialScripts = () => {
  const { performanceTracking } = useUser();
  return (
    <>
      <OptimizelyScript />
      <PushlyScript />
      {performanceTracking && (
        <>
          <AmplitudeScript />
          <MixpanelScript />
        </>
      )}
    </>
  );
};
